import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import Hero from "./hero";
import Footer from "./footer";
import ScrollTriggerSimple from "../helpers/scrollTriggerSimple";

function Homepage() {
  // const buttonclassName =
  //   "text-xs mt-16 bg-transparent hover:bg-[#141833] text-[#141833] sm:text-[16px] sm:leading-[25px] xl:text-[20px] xl:leading-[30px] font-gothMed hover:text-white py-3 px-8 border border-[#707070] hover:border-transparent rounded";

  const bodyCopyclassName = "xs:text-center sm:text-center xs:px-5 xs:py-10 sm:px-10 sm:py-20 lg:py-36 xs:text-[22px] xs:leading-[30px] sm:text-[25px] sm:leading-[38px] xl:text-[30px] xl:leading-[45px] font-ppNeue";

  const informationCopyclassName = "content-end xs:text-center lg:text-left m-auto xs:text-1xl sm:text-1xl md:text-1xl text-[#141833] lg:text-1xl lg:!leading-[2rem]  xl:text-lg xl:!leading-[2rem]  pt-6 font-ppNeue";

  const linkCopy = "text-left m-auto xs:text-3xl sm:text-3xl md:text-3xl text-[#141833] md:w-[700px] lg:text-4xl lg:!leading-[3rem] lg:w-[800px] xl:text-5xl xl:!leading-[4rem] xl:w-[1200px] px-0 mx-0 font-ppNeue";

  const navBgProperty = useRef();
  const t2 = useRef();

  const { ref: propertyHeader0 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyCopy0 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyButton0 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyimage0 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyInformation } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyimage1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyHeader1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyCopy1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyimage2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyCopy3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  //const { ref: propertyButton1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyimage3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyCopy4 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyCopy5 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyimage4 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyCopy6 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyimage5 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  //const { ref: propertyHeader2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyButton2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyBlackLogo } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyHeader3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyimage6 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyAddress1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyAddress2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: propertyAddress3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyAddress4 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: propertyMap } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");

  const slideIn = () => {
    // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    navBgProperty.current.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
    gsap.delayedCall(0.5, function () {
      t2.current = gsap.timeline().to(navBgProperty.current, { duration: 0.5, left: "0" }, "<");
    });
  };

  useEffect(() => {});

  return (
    <>
      <Hero heroImg={"propertyHero"} title={""} />
      <section className="overflow-hidden">
        <article className="xs:py-20 xs:px-5 sm:py-36 md:py-36 lg:py-50 bg-[#141833] flex flex-col">
          <p ref={propertyHeader0} className="content-center text-center m-auto xs:text-2xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-4xl lg:!leading-[3rem] lg:w-[800px] xl:text-4xl xl:!leading-[3rem] xl:w-[1000px] sm:px-4 xl:px-12 font-ppNeue">
            THE VERTICALS
          </p>
          <p ref={propertyCopy0} className="content-center text-center m-auto xs:text-2xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-4xl lg:!leading-[3rem] lg:w-[800px] xl:text-4xl xl:!leading-[3rem] xl:w-[1000px] sm:px-4 xl:px-12 pt-12 font-ppNeue">
            The Verticals by Chaldean Prime is an exclusive development which will elevate you to a new level of unparalleled luxury living.
          </p>
          <button
            ref={propertyButton0}
            onClick={slideIn}
            className="text-xs mt-16 m-auto bg-transparent hover:bg-[#EDB6A2] text-[#EDB6A2] sm:text-[16px] sm:leading-[25px] xl:text-[20px] xl:leading-[30px] font-gothMed hover:text-white py-3 px-8 border border-[#707070] hover:border-transparent rounded"
          >
            GET IN TOUCH
          </button>
        </article>
        <article className="items-center xs:block lg:flex lg:p-20 xl:p-24">
          <div className="xs:w-full lg:w-4/6 text-left">
            <img ref={propertyimage0} className="inline-block" alt="" src="../images/propertyImage1.jpg"></img>
          </div>
          <div ref={propertyInformation} className="inline-block align-middle xs:w-full lg:w-2/6 xs:pl-0 lg:pl-32">
            <p className={informationCopyclassName}>
              <b>LOCATION</b>
              <br></br>
              Mill Hill, London, NW7
            </p>
            <p className={informationCopyclassName}>
              <b>TYPE</b>
              <br></br>
              Residential
            </p>
            <p className={informationCopyclassName}>
              <b>RESIDENCES</b>
              <br></br>
              Four homes
            </p>
            {/* <p className={informationCopyclassName}>
              <b>ARCHITECT</b>
              <br></br>
              Hoerr Schaudt
            </p>
            <p className={informationCopyclassName}>
              <b>STATUS</b>
              <br></br>
              Two plots left for sale
            </p> */}
          </div>
        </article>
        <article className="text-center xs:pt-8 lg:py-0 lg:px-20 xl:px-24">
          <img ref={propertyimage1} className="inline-block" alt="" src="../images/propertyImage2.jpg"></img>
        </article>
        <article className="xs:w-[100%] xl:w-[1200px] sm:text-left xs:px-5 xs:py-10 sm:px-10 md:pl-20 lg:pl-28 xl:pl-60 sm:py-20 lg:py-36 xs:text-[26px] xs:leading-[30px] sm:text-[38px] sm:leading-[48px] xl:text-[38px] xl:leading-[30px] font-ppNeue">
          <p ref={propertyHeader1} className="pb-6">
            Elevating you to new levels of luxury
          </p>
          <p ref={propertyCopy1} className="xs:text-[14px] md:text-[18px] xs:leading-[20px] md:leading-[30px] xs:pl-0 xs:pt-6 md:pt-6 md:pl-0">
            From the handmade bricks used in construction, to the private elevators and playful pyjama lounges, these homes are unique. For the first time in North-West London you have the opportunity to feel like you’re waking up in a luxury hotel each day. Quite simply these homes are the makings
            of dreams.
          </p>
          {/* <small
              ref={propertyCopy2}
              className="xs:text-[14px] md:text-[18px] xs:leading-[20px] md:leading-[30px] xs:pl-0 xs:pt-6 md:pt-0 md:pl-6"
            >
              Chaldean’s superior interior design team have set the bar mighty high in the
              specification, aesthetics and finish at The Verticals. These properties offer an
              apartment lifestyle in a very prestigious statement home. From handmade-to-order
              bricks used in the construction to the bespoke cabinetry, luxury white goods and
              top-of-the-range kitchen equipment. Everything is designed with your security, comfort
              and confidence in mind.{" "}
            </small> */}
        </article>
        <article className="text-right">
          <img ref={propertyimage2} className="inline-block" alt="" src="../images/propertyImage3.jpg"></img>
        </article>
        <article className={bodyCopyclassName}>
          <p ref={propertyCopy3} className="xs:w-[100%] md:w-[800px] xl:w-[1200px] m-auto">
            The Verticals will give you the opportunity to enjoy a simpler, stress-free experience. It is apartment-style living enveloped in the freedom of a freehold home; the joy and liberty of the downsized lifestyle without the institutional feel of a block of flats.
          </p>
          {/* <button ref={propertyButton1} className={buttonclassName}>
            DOWNLOAD BROCHURE
          </button> */}
        </article>
        <article className="text-left">
          <img ref={propertyimage3} className="inline-block" alt="" src="../images/homepage2.jpg"></img>
        </article>
        <article className=" xs:w-[100%] md:w-[800px] xl:w-[1200px] sm:text-left xs:px-5 xs:py-10 sm:px-10 md:pl-20 lg:pl-28 xl:pl-60 sm:py-20 lg:py-36 xs:text-[22px] xs:leading-[30px] lg:text-[25px] lg:leading-[46px] xl:text-[30px] xl:leading-[45px] font-ppNeue">
          <p ref={propertyCopy4}>
            The principal suite, with its own pyjama lounge and luxurious ‘his’ and ‘hers’ ensuites, and dressing rooms, occupies the entire first floor and is the size of an entire one-bedroom apartment! There are a further two guest bedrooms with private facilities on the second floor. Each is
            generously proportioned with a fabulous finish.
          </p>
        </article>
        <article className="text-right">
          <img ref={propertyimage4} className="inline-block" alt="" src="../images/propertyImage5.jpg"></img>
        </article>
        <article className={bodyCopyclassName}>
          <p ref={propertyCopy5} className="xs:w-[100%] md:w-[800px] xl:w-[1200px] m-auto">
            Kitchens at The Verticals are the height of cool sophistication. The very latest labour-saving Miele appliances are blended with the smartest work surfaces and bespoke Poggenpohl cabinets to create a delightful space in which to work your culinary magic.
          </p>
        </article>
        <article className="text-center lg:py-0 lg:px-20 xl:px-24">
          <img ref={propertyimage5} className="inline-block" alt="" src="../images/propertyImage6.jpg"></img>
        </article>
        <article className={bodyCopyclassName}>
          <p ref={propertyCopy6} className="xs:w-[100%] md:w-[800px] xl:w-[1200px] m-auto">
            Bathrooms at The Verticals transform your daily routine into an aesthetic experience to delight the senses. The beautiful baths, basins and intense showers are paired with the finest imported porcelain tiles and warm, relaxing lighting to immerse you in luxury
          </p>
        </article>
        <article className="items-center bg-[#141833] xs:block lg:flex">
          <div className="w-2/4 text-left">
            <img ref={propertyimage6} className="xs:hidden lg:inline-block" alt="" src="../images/designFooter1.jpg"></img>
          </div>
          <div className="inline-block align-middle xs:w-full lg:w-2/4 xs:pl-0 xs:py-16 lg:pl-32">
            {/* <h1
              ref={propertyHeader2}
              className="content-center xs:text-center lg:text-left xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] lg:text-4xl lg:!leading-[3rem] xl:text-4xl xl:!leading-[3.2rem] font-ppNeue xs:pb-8 lg:pb-0"
            >
              SECOND PROJECT NAME
            </h1> */}
            <a href="/properties" rel="none">
              <button ref={propertyButton2} className="text-xs mt-16 bg-transparent hover:bg-[#EDB6A2] text-[#EDB6A2] sm:text-[16px] sm:leading-[25px] xl:text-[20px] xl:leading-[30px] font-gothMed hover:text-white py-3 px-8 border border-[#707070] hover:border-transparent rounded">
                BACK TO PROJECTS
              </button>
            </a>
          </div>
        </article>
      </section>
      <section ref={navBgProperty} className="overflow-hidden bg-no-repeat bg-center bg-cover xs:h-[auto] md:h-[600px] w-full xs:px-6 sm:px-12 lg:px-36 xs:pb-12 md:pb-32 xs:pt-6 md:pt-12 relative top-0 bg-white">
        <div className="flex">
          <article className="xs:w-full sm:w-1/5">
            <a href="/">
              <img ref={propertyBlackLogo} alt="logo" className="xs:w-[125px] sm:w-[219px] max-w-none" src="../images/hero-logo-dark.png"></img>
            </a>
          </article>
        </div>
        <article className="w-full">
          <nav className="xs:pt-8 sm:pt-8 text-left">
            <h2 ref={propertyHeader3} className={linkCopy}>
              Get In Touch
            </h2>
            <div className="w-full relative text-left text-[#141833]">
              <p ref={propertyAddress1} className="pt-10">
                The Chaldean Estate<br></br> Old Grain Store<br></br> Bromley Lane
                <br></br> Much Hadham<br></br>Hertfordshire<br></br>SG10 6HU
              </p>
              <p ref={propertyAddress2} className="pt-10">
                hello@chaldean-prime.co.uk
              </p>
              <p ref={propertyAddress4}>
                Press and Media Enquiries:<br></br>
                hello@shakastudio.co.uk
              </p>
            </div>
          </nav>
        </article>
        <iframe
          ref={propertyMap}
          title="myFrame"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2463.757760748533!2d0.061640916344945444!3d51.86537919228586!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8833b10424605%3A0x6b98af6308bbbf61!2sChaldean%20Estate%20Ltd!5e0!3m2!1sen!2suk!4v1676832220511!5m2!1sen!2suk"
          width="60%"
          className="xs:realtive xs:h-[400px] md:h-full xs:w-full md:w-[60%] md:absolute xs:pt-12 md:pt-0 top-0 right-0 z-0 grayscale"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
      <Footer />
    </>
  );
}

export default Homepage;
